import { StyleSheet } from "react-native";
import { useTheme } from "../hooks/use-theme";
import { useMemo } from "react";
import Text from "../components/Text";

type ListTitleProps = {
    value: string;
    isFirst?: boolean;
};

const ListTitle = ({ value, isFirst }: ListTitleProps) => {
    const styles = useStyles();
    return <Text style={[styles.text, isFirst && styles.firstTitle]}>{value}</Text>;
};

const useStyles = () => {
    const { gridSize, fonts, marginSize } = useTheme();
    return useMemo(
        () =>
            StyleSheet.create({
                firstTitle: {
                    marginTop: 0,
                },
                text: {
                    alignSelf: "stretch",
                    alignContent: "flex-start",
                    flexDirection: "row",
                    paddingLeft: marginSize,
                    paddingRight: marginSize,
                    marginTop: gridSize,
                    marginBottom: marginSize,
                    ...fonts.bodyLarge,
                },
            }),
        [fonts.bodyLarge, gridSize, marginSize],
    );
};

export default ListTitle;
